import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, Observable, of, tap } from 'rxjs';
import { SessionData } from '../../core/session-data';
import { SessionService } from '../../core/session.service';

export interface AirlineInfo {
  airlineName: string;
  airlineCode: string;
}

@Injectable({
  providedIn: 'root'
})
export class DictionaryService {

  private airlinesCached: Array<AirlineInfo>;
  private sessionData: SessionData;

  constructor(
    private http: HttpClient,
    private sessionService: SessionService
  ) {
    this.sessionData = this.sessionService.getSessionData();
  }

  public get airlines(): Observable<Array<AirlineInfo>> {

    if (this.airlinesCached && this.airlinesCached.length > 0) {
      return of(this.airlinesCached);
    }

    return this.http
      .get<any>(this.sessionData.apiUrl + '/dictionaries/airlines')
      .pipe(
        map(response => {
          return <Array<AirlineInfo>>response.airlines;
        }),
        tap(airlines => {
          this.airlinesCached = airlines || [];
        }));
  }
}
